'use memo';

import { Outlet, createFileRoute, useMatchRoute } from '@tanstack/react-router';
import { NotFound } from '@/components/Error/NotFound';
import ListPageHeader from '@/components/ListPageHeader';
import { ProductLogoMediumPayroll } from '@/components/Logo';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { featureFlags } from '@/lib/env';
import { defaultNS, useTranslation } from '@/lib/i18n';
import { legalWelfareAndTaxesKeyPrefix } from './-utils/i18n';
export const Route = createFileRoute('/_staff/legal-welfare-and-taxes-mock/_layout')({
  component: Layout
});
function Layout() {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: legalWelfareAndTaxesKeyPrefix
  });
  useDocumentTitle(t($ => $.pageTitle));
  const matchRoute = useMatchRoute();
  /**
   * 詳細ページは自前で一覧へ戻る導線とタイトルを持つため、モジュールの
   * ListPageHeader は出さない（給与・賃金の詳細と同じ扱い）。
   */
  const isDetailPage = Boolean(matchRoute({
    to: '/legal-welfare-and-taxes-mock/statutory-standards/$standardId',
    fuzzy: true
  }));

  /* 中身は給与・賃金から移した mock なので、ゲートも同じフラグに合わせる */
  if (!featureFlags.check('LABOR_PLUS_MOCK')) {
    return <NotFound />;
  }
  return <div className="flex h-full min-h-0 min-w-0 flex-col">
      {!isDetailPage ? <ListPageHeader icon={<ProductLogoMediumPayroll />} title={t($ => $.pageTitle)} tabs={[{
      to: '/legal-welfare-and-taxes-mock/statutory-standards',
      children: t($ => $.tabs.statutoryStandards),
      activeOptions: {
        exact: false
      }
    }]} /> : null}
      <div className="flex min-h-0 min-w-0 flex-1 flex-col">
        <Outlet />
      </div>
    </div>;
}